// mddCalc.js — wrapper around labEngine.mdd() (IS 2720 Part 8:1983, heavy compaction) with input sanity checks.
import { mdd } from '../labEngine';

const CLAUSE = 'IS 2720-8:1983';
export const MOULDS = [
  { volumeCc: 1000, label: '1000 cc (100 mm)', blows: 25 },
  { volumeCc: 2250, label: '2250 cc (150 mm)', blows: 55 },
];

// trials = [{ mouldSoilG, wetG, dryG, tareG }]
export function computeMDD({ mouldVolumeCc, mouldMassG, procedure, retained19Pct, gs = null, trials }) {
  const issues = [];
  let bad = false;
  const block = (code, msg, clause = CLAUSE) => { bad = true; issues.push({ level: 'block', code, clause, msg }); };

  const mould = MOULDS.find((m) => m.volumeCc === mouldVolumeCc);
  if (!mould) block('MOULD', 'Select the mould (1000 cc or 2250 cc)');
  if (!(mouldMassG > 0)) block('MOULD_MASS', 'Mould weight must be above 0');
  if (!(retained19Pct >= 0 && retained19Pct <= 100)) block('RETAINED_19', '% retained on 19 mm must be between 0 and 100');
  if (gs != null && !(gs > 1 && gs < 4)) block('GS', 'Specific gravity should be between 1 and 4', 'IS 2720-3');
  if (!trials.length) block('TRIALS', 'Enter at least one trial');

  trials.forEach((t, i) => {
    const tag = `Trial ${i + 1}`;
    if (!(t.mouldSoilG > mouldMassG)) block('MOULD_SOIL', `${tag}: mould + compacted soil must be more than the empty mould`);
    if (!(t.tareG > 0)) block('MC', `${tag}: container weight must be above 0`, 'IS 2720-2:1973');
    else if (!(t.dryG > t.tareG)) block('MC', `${tag}: container + dry must be more than the container`, 'IS 2720-2:1973');
    else if (!(t.wetG >= t.dryG)) block('MC', `${tag}: container + wet must be at least container + dry`, 'IS 2720-2:1973');
  });
  if (bad) return { result: null, issues };

  const out = mdd({
    mould: { volumeCc: mould.volumeCc, massG: mouldMassG }, rammerKg: 4.9, layers: 5, blowsPerLayer: mould.blows,
    retained19Pct, procedure, maxSizeMm: 19, trials,
  });
  const result = out.result && {
    ...out.result, mould, procedure, gs,
    // zero-air-voids (100 % saturation) density at each trial's water content — only if Gs is known
    zav: gs ? out.result.points.map((p) => gs / (1 + (p.w / 100) * gs)) : null,
  };
  return { result, issues: [...issues, ...out.issues].filter(Boolean) };
}
